import RobotCard from "./RobotCard";
import bellabotImage from "@/assets/bellabot-3.png";
import kettybotProImage from "@/assets/robots/kettybot-pro-variants-new.jpeg";
import cc1Image from "@/assets/cc1-light.png";
import t600Image from "@/assets/robots/pudu-t600-updated.png";

const ServicesSection = () => {
  const robots = [
    {
      name: "BellaBot Pro",
      description: "Advanced delivery robot with interactive display and voice capabilities for restaurants and hospitality.",
      icon: "🤖",
      image: bellabotImage,
      roiMetric: "Cuts 2-3 server hours/shift · Lifts table turns 10-15%"
    },
    {
      name: "KettyBot Pro",
      description: "Multi-functional service robot with advertising display, perfect for marketing and customer engagement.",
      icon: "🎯",
      image: kettybotProImage,
      roiMetric: "Boosts upsell conversion 8-12% with dynamic ads"
    },
    {
      name: "CC1 Pro",
      description: "Intelligent cleaning robot for floors and carpets with autonomous navigation and scheduling.",
      icon: "🧹",
      image: cc1Image,
      roiMetric: "Replaces 1–1.5 FTE/night in large facilities"
    },
    {
      name: "PUDU T600",
      description: "Heavy-payload industrial delivery robot with 600kg capacity. Built-in touch screen, autonomous navigation, and 12-hour battery life for 24/7 operations.",
      icon: "🏢",
      image: t600Image,
      roiMetric: "600kg payload • Multi-floor capable"
    },
    {
      name: "AI Voice Systems",
      description: "Automated customer service, scheduling, and lead generation with natural language processing.",
      icon: "🎤",
      roiMetric: "24/7 answering · Captures 35-60% of missed calls"
    },
    {
      name: "CRM Automation",
      description: "Streamline workflows with GoHighLevel integration, AI agents, and intelligent lead nurturing.",
      icon: "⚙️",
      roiMetric: "Shortens sales cycle 20-30%"
    }
  ];

  return (
    <section className="py-16">
      <div className="text-center mb-12">
        <h2 className="font-orbitron font-bold text-4xl md:text-5xl mb-4">
          Our <span className="text-primary">AI Solutions</span>
        </h2>
        <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
          From intelligent robots to voice systems and CRM integration — complete solutions to transform your operations.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {robots.map((robot) => (
          <RobotCard key={robot.name} {...robot} />
        ))}
      </div>
    </section>
  );
};

export default ServicesSection;
